import React, { Component } from 'react';


class FlagSpecial extends Component {

  translateCountryName(countryName) {
    const list = {
      "Mundo": "fifa",
      "Ásia": "afc",
      "África": "caf",
      "América do Sul": "xcsf",
      "Europa": "UEFA_logo",
      "América do Norte e Central": "concaf",
      "Oceânia": "ofc",
    }
    let countryCode = "";
    if (list.hasOwnProperty(countryName)) {
      countryCode = list[countryName];
    }
    return countryCode;
  }

  render3Letters(name) {
    return <span>{name.substring(0, 3).toUpperCase()}</span>
  }

  renderFlag(code) {
    return (
      <img
        alt={this.props.code}
        src={"/img/special-flags/" + code + ".png"}
      />
    )
  }

  render() {
    const countryCode = this.translateCountryName(this.props.code);
    return (


      this.renderFlag(countryCode)
    );
  }
}

export default FlagSpecial;